export const ru = {
  tasks: {
    indicator: {
      label: 'Фоновые задачи',
      labelActive: { one: 'Фоновые задачи: идёт {n}', few: 'Фоновые задачи: идут {n}', many: 'Фоновые задачи: идут {n}', other: 'Фоновые задачи: идут {n}' },
      title: 'Фоновые задачи',
      empty: 'Сейчас ничего не идёт.',
      allBlog: 'Все задачи блога',
      allPlatform: 'Все задачи платформы',
    },
    kinds: {
      mediaRecompress: 'Пережатие исходников',
      mediaStorageRecount: 'Пересчёт объёма медиа',
      operationsBackup: 'Резервная копия',
      operationsRestore: 'Восстановление из копии',
    },
    statuses: {
      queued: 'В очереди',
      running: 'Выполняется',
      paused: 'Приостановлена',
      completed: 'Завершена',
      completedWithErrors: 'Завершена с ошибками',
      cancelled: 'Отменена',
    },
    card: {
      platform: 'Платформа',
      steps: '{done} из {total}',
      volume: '{done} из {total}',
      failed: { one: '{n} ошибка', few: '{n} ошибки', many: '{n} ошибок', other: '{n} ошибки' },
      skipped: { one: '{n} пропущен', few: '{n} пропущено', many: '{n} пропущено', other: '{n} пропущено' },
      current: 'Сейчас: {label}',
      currentShare: 'Сейчас: {label} — {percent}%',
      cancelling: 'Отменяется…',
      pauseReason: 'Причина: {reason}',
      createdBy: 'Поставлена: {name}, {at}',
      createdBySystem: 'Поставлена системой, {at}',
      finishedAt: 'Окончена {at}',
      progress: 'Прогресс задачи «{title}»',
      report: 'Отчёт',
      cancel: 'Отменить',
      resume: 'Возобновить',
      cancelConfirm: 'Отменить задачу «{title}»?',
      cancelText: 'Сделанное останется, текущий шаг прервётся и не применится, остальное не выполнится.',
    },
    page: {
      section: 'Фоновые задачи',
      subtitle: 'Долгая работа в фоне: идущие и завершённые задачи, их прогресс и отчёты. Завершённые хранятся ограниченное время.',
      empty: 'Фоновых задач не было',
      emptyText: 'Здесь появится, например, пережатие исходников из раздела «Хранилище медиа».',
      back: '← Все задачи блога',
    },
    admin: {
      title: 'Фоновые задачи',
      subtitle: 'Задачи всех блогов и платформы. Содержимое блогов, где вы не участник, не показывается — только счётчики и объёмы.',
      filter: 'Показать',
      filters: { active: 'Идущие', all: 'Все' },
      empty: 'Задач нет',
    },
  },
};

export const en: typeof ru = {
  tasks: {
    indicator: {
      label: 'Background tasks',
      labelActive: { one: 'Background tasks: {n} running', few: 'Background tasks: {n} running', many: 'Background tasks: {n} running', other: 'Background tasks: {n} running' },
      title: 'Background tasks',
      empty: 'Nothing is running now.',
      allBlog: 'All blog tasks',
      allPlatform: 'All platform tasks',
    },
    kinds: {
      mediaRecompress: 'Source recompression',
      mediaStorageRecount: 'Media volume recount',
      operationsBackup: 'Backup',
      operationsRestore: 'Restore from backup',
    },
    statuses: {
      queued: 'Queued',
      running: 'Running',
      paused: 'Paused',
      completed: 'Completed',
      completedWithErrors: 'Completed with errors',
      cancelled: 'Cancelled',
    },
    card: {
      platform: 'Platform',
      steps: '{done} of {total}',
      volume: '{done} of {total}',
      failed: { one: '{n} error', few: '{n} errors', many: '{n} errors', other: '{n} errors' },
      skipped: { one: '{n} skipped', few: '{n} skipped', many: '{n} skipped', other: '{n} skipped' },
      current: 'Now: {label}',
      currentShare: 'Now: {label} — {percent}%',
      cancelling: 'Cancelling…',
      pauseReason: 'Reason: {reason}',
      createdBy: 'Started by {name}, {at}',
      createdBySystem: 'Started by the system, {at}',
      finishedAt: 'Finished {at}',
      progress: 'Progress of task “{title}”',
      report: 'Report',
      cancel: 'Cancel',
      resume: 'Resume',
      cancelConfirm: 'Cancel task “{title}”?',
      cancelText: 'What is done stays; the current step is interrupted and not applied, the rest is not done.',
    },
    page: {
      section: 'Background tasks',
      subtitle: 'Long work in the background: running and finished tasks, their progress and reports. Finished tasks are kept for a limited time.',
      empty: 'No background tasks yet',
      emptyText: 'For example, source recompression from “Media storage” will show up here.',
      back: '← All blog tasks',
    },
    admin: {
      title: 'Background tasks',
      subtitle: 'Tasks of all blogs and the platform. Content of blogs you are not a member of is hidden — only counters and volumes.',
      filter: 'Show',
      filters: { active: 'Running', all: 'All' },
      empty: 'No tasks',
    },
  },
};
